<template>
  <div class="relative flex h-full pt-6 pb-10">
    <form class="relative w-2/3 mx-auto bg-white shadow-xl rounded-lg p-4 pb-64 overflow-hidden">
      <div class="flex w-full">
        <div class="flex items-center mb-6 w-1/2">
          <div class="md:w-1/3">
            <label
              class="block text-gray-900 font-bold md:text-right mb-1 md:mb-0 pr-4"
              for="qName"
            >Nombre:</label>
          </div>
          <div class="md:w-2/3">
            <input
              :class="{'border-red-500': errors.emptyName}"
              class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-teal-500"
              id="qName"
              type="text"
              v-model="formName"
            />
            <p
              v-if="errors.emptyName"
              class="text-red-500 text-xs italic text-left"
            >Ingrese el nombre del cuestionario.</p>
          </div>
        </div>
        <div class="flex items-center mb-6 w-1/2">
          <div class="md:w-1/3">
            <label
              class="block text-gray-900 font-bold md:text-right mb-1 md:mb-0 pr-4"
              for="qName"
            >Categoría:</label>
          </div>
          <div class="md:w-2/3">
            <div class="w-full relative">
              <select
                :class="{'border-red-500': errors.emptyCategory}"
                class="block appearance-none w-full bg-gray-200 border-2 border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-teal-500"
                name="status"
                id="status"
                v-model="categoryId"
              >
                <template v-for="category in formCategories">
                  <option :key="category.id" :value="category.id">{{category.category_name}}</option>
                </template>
              </select>
              <div
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
              >
                <svg
                  class="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
            <p
              v-if="errors.emptyCategory"
              class="text-red-500 text-xs italic text-left"
            >Seleccione una categoría.</p>
          </div>
        </div>
      </div>

      <div class="flex items-center mb-6 w-full">
        <div class="md: w-2/12">
          <label
            class="block text-gray-900 font-bold md:text-right mb-1 md:mb-0 pr-4"
            for="description"
          >Descripción:</label>
        </div>
        <div class="md:w-10/12">
          <textarea
            class="appearance-none block w-full h-16 bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white resize-none"
            id="description"
            type="text"
            name="description"
            v-model="description"
          />
        </div>
      </div>

      <div class="flex flex-wrap items-center justify-end mb-4">
        <button
          type="button"
          class="flex items-center px-4 py-2 rounded-full bg-teal-500 text-gray-100 hover:bg-teal-700 mb-2"
          @click="addQuestion('open')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            class="h-6 w-6 fill-current"
            viewBox="0 0 24 24"
          >
            <defs>
              <path id="a" d="M0 0h24v24H0V0z" />
            </defs>
            <clipPath id="b">
              <use xlink:href="#a" overflow="visible" />
            </clipPath>
            <path d="M4 9h16v2H4zm0 4h10v2H4z" clip-path="url(#b)" />
          </svg>
          <span class="ml-2 text-sm tracking wide font-bold">Pregunta abierta</span>
        </button>
        <button
          type="button"
          class="flex items-center px-4 py-2 ml-2 rounded-full bg-indigo-500 text-gray-100 hover:bg-indigo-700 mb-2"
          @click="addQuestion('multiple')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 24 24">
            <path
              d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
          <span class="ml-2 text-sm tracking wide font-bold">Opción múltiple</span>
        </button>
        <button
          type="button"
          class="flex items-center px-4 py-2 ml-2 rounded-full bg-orange-500 text-gray-100 hover:bg-orange-700 mb-2"
          @click="addQuestion('scale')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            class="h-6 w-6 fill-current"
            viewBox="0 0 24 24"
          >
            <defs>
              <path id="a" d="M0 0h24v24H0V0z" />
            </defs>
            <clipPath id="b">
              <use xlink:href="#a" overflow="visible" />
            </clipPath>
            <path
              clip-path="url(#b)"
              d="M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z"
            />
          </svg>
          <span class="ml-2 text-sm tracking wide font-bold">Escala lineal</span>
        </button>
        <button
          type="button"
          class="flex items-center px-4 py-2 ml-2 rounded-full bg-purple-500 text-gray-100 hover:bg-purple-700 mb-2"
          @click="addQuestion('rating')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
          <span class="ml-2 text-sm tracking wide font-bold">Calificación</span>
        </button>
        <button
          type="button"
          class="flex items-center px-4 py-2 ml-2 rounded-full bg-blue-500 text-gray-100 hover:bg-blue-700 mb-2"
          @click="addQuestion('multimedia')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z"
            />
          </svg>
          <span class="ml-2 text-sm tracking wide font-bold">Multimedia</span>
        </button>
        <button
          type="button"
          class="flex items-center px-4 py-2 ml-2 rounded-full bg-pink-500 text-gray-100 hover:bg-pink-700 mb-2"
          @click="addQuestion('geolocation')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 24 24">
            <path fill="none" d="M0 0h24v24H0V0z" />
            <path d="M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z" />
          </svg>
          <span class="ml-2 text-sm tracking wide font-bold">Geolocalización</span>
        </button>
      </div>
      <div class="mb-6">
        <p
          v-if="errors.emptyForm"
          class="text-red-500 text-xs italic text-right"
        >Agregue al menos una pregunta.</p>
      </div>
      <div class="h-full overflow-auto">
        <div v-for="(question, index) in questions" :key="question.id">
          <open-question
            v-if="question.type === 'open'"
            @click="removeQuestion(index)"
            :question="question"
          ></open-question>
          <multiple-question
            v-if="question.type === 'multiple'"
            @click="removeQuestion(index)"
            :question="question"
          ></multiple-question>
          <scale-question
            v-if="question.type === 'scale'"
            @click="removeQuestion(index)"
            :question="question"
          ></scale-question>
          <rating-question
            v-if="question.type === 'rating'"
            @click="removeQuestion(index)"
            :question="question"
          ></rating-question>
          <multimedia-question
            v-if="question.type === 'multimedia'"
            @click="removeQuestion(index)"
            :question="question"
          ></multimedia-question>
          <geolocation-question
            v-if="question.type === 'geolocation'"
            @click="removeQuestion(index)"
            :question="question"
          ></geolocation-question>
        </div>
      </div>
    </form>
    <div class="absolute inset-y-0 left-0 w-1/6 pt-6 flex flex-col">
      <button
        type="button"
        class="mx-6 px-4 py-2 bg-primary-color hover:bg-primary-color-dark rounded-lg text-white font-bold shadow-lg"
        @click="updateForm"
      >Actualizar</button>
      <router-link
        to="/cuestionarios"
        class="mt-4 mx-6 px-4 py-2 bg-red-500 hover:bg-danger-color rounded-lg text-white font-bold shadow-lg"
      >Cancelar</router-link>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Encuesta guardada</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-400"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import OpenQuestion from "./OpenQuestion";
import MultipleQuestion from "./MultipleQuestion";
import ScaleQuestion from "./ScaleQuestion";
import RatingQuestion from "./RatingQuestion";
import MultimediaQuestion from "./MultimediaQuestion";
import GeolocationQuestion from "./GeolocationQuestion";
import AlertDialog from "./AlertDialog";

export default {
  name: "form-edit-builder",
  data: function() {
    return {
      description: null,
      lastId: 0,
      aux_formName: null,
      formName: "",
      questions: [],
      formId: null,
      showingSuccess: false,
      showingError: false,
      errors: {
        emptyName: false,
        emptyForm: false,
        emptyCategory: false
      },
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      formCategories: [],
      categoryId: 0
    };
  },
  created(){
    let that = this;
/*     this.$socket.$subscribe("updateCategoryPollToMonitor", () => {
      that.fetchFormCategories();
    }); */
  },
  mounted() {
    this.formId = this.$route.params.id;
    this.fetchFormCategories();
    this.fetchForm(this.formId);
  },
  components: {
    OpenQuestion,
    MultipleQuestion,
    ScaleQuestion,
    RatingQuestion,
    MultimediaQuestion,
    GeolocationQuestion,
    AlertDialog
  },
  methods: {
    fetchForm(formId) {
      this.axios
        .get("apidev/api/polls/" + formId, this.config)
        .then(response => {
          let form = response.data;
          this.description = form.description;
          this.formName = form.nombre;
          this.aux_formName = form.nombre;
          this.questions = form.preguntas;
          this.lastId = this.questions.length;
          this.categoryId = form.id_categoria;
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          // removed console log
        });
    },
    addQuestion(type) {
      if (type === "open") {
        let question = {
          id: this.lastId,
          value: "",
          type: type,
          error: false
        };
        this.questions.push(question);
        this.lastId += 1;
      }
      if (type === "multiple") {
        let question = {
          id: this.lastId,
          value: "",
          type: type,
          options: [""],
          error: false,
          optionError: false
        };
        this.questions.push(question);
        this.lastId += 1;
      }
      if (type === "scale") {
        let question = {
          id: this.lastId,
          value: "",
          type: type,
          range: [0, 5],
          labels: [],
          error: false
        };
        this.questions.push(question);
        this.lastId += 1;
      }
      if (type === "rating") {
        let question = {
          id: this.lastId,
          value: "",
          type: type,
          icon: "",
          error: false
        };
        this.questions.push(question);
        this.lastId += 1;
      }
      if (type === "multimedia") {
        let question = {
          id: this.lastId,
          value: "",
          type: type,
          error: false,
          optionError: false
        };
        this.questions.push(question);
        this.lastId += 1;
      }
      if (type === "geolocation") {
        let question = {
          id: this.lastId,
          value: "",
          type: type,
          error: false
        };
        this.questions.push(question);
        this.lastId += 1;
      }
    },
    removeQuestion(questionKey) {
      this.questions.splice(questionKey, 1);
    },
    validateForm() {
      if (this.formName === "") {
        this.errors.emptyName = true;
        return false;
      } else {
        this.errors.emptyName = false;
      }
      if (this.categoryId === 0) {
        this.errors.emptyCategory = true;
      } else {
        this.errors.emptyCategory = false;
      }
      if (this.questions.length === 0) {
        this.errors.emptyForm = true;
        return false;
      } else {
        this.errors.emptyForm = false;
      }

      let validQuestions = true;
      this.questions.forEach(question => {
        if (question.value === "") {
          question.error = true;
          validQuestions = false;
        } else {
          question.error = false;
        }
        if (question.type === "multiple") {
          for (let i = 0; i < question.options.length; i++) {
            if (question.options[i] === "") {
              question.optionError = true;
              validQuestions = false;
              break;
            } else {
              question.optionError = false;
            }
          }
        }
        if (question.type === "multimedia") {
          if (question.fileType) {
            question.optionError = false;
            if (question.fileType === "photo") {
              question.photo = true;
              question.video = false;
            } else {
              question.photo = false;
              question.video = true;
            }
          } else {
            question.optionError = true;
            validQuestions = false;
          }
          /* if (question.photo || question.video) {
            question.optionError = false;
          } else {
            question.optionError = true;
            validQuestions = false;
          } */
        }
      });

      if (validQuestions) {
        return true;
      } else {
        return false;
      }
    },
    updateForm() {
      let validForm = this.validateForm();
      if (validForm) {
        this.questions.forEach((question, index) => {
          question.id = index;
        });

        let form = {
          nombre: this.formName,
          preguntas: this.questions,
          id_categoria: this.categoryId,
          description: this.description
        };

        this.axios
          .put("apidev/api/polls/" + this.formId, form, this.config)
          .then(response => {
            let observation = ""
            if(this.formName != this.aux_formName){
              observation = `${this.aux_formName} / ${this.formName}`
            } else {
              observation = `${this.formName}`
            }
            return this.axios.post("apidev/api/binnacles/monitor/save/",{
                "module": "Encuestas", 
                "action": "Edición de una encuesta", 
                "observation": observation,
                "email": localStorage.getItem("email")
              },
              this.config
            )
          })
          .then(response => {
            this.showingSuccess = true;
          })
          .catch(error => {
            if (error.response.status == 400 || error.response.status == 401) {
              if (
                error.response.data.name === "TokenExpiredError" ||
                error.response.data.name === "InvalidTokenError" ||
                error.response.data.name === "JsonWebTokenError"
              ) {
                this.$router.push({ path: "/login" });
              }
            }
            this.showingError = true;
          });
      }
    },
    fetchFormCategories() {
      this.axios
        .get("apidev/api/polls/categories/listAll", this.config)
        .then(response => {
          this.formCategories = response.data;
        })
        .catch(error => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>